import {
  IconButton
} from "./chunk-4IBR4GAB.mjs";
import {
  Close_default
} from "./chunk-ONOYXPIT.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/drawer/drawer-close-trigger.tsx
import * as Dialog from "@radix-ui/react-dialog";
import React, { forwardRef } from "react";
var DrawerCloseTrigger = forwardRef(function DrawerCloseTrigger2({ className, ...props }, ref) {
  return /* @__PURE__ */ React.createElement(Dialog.Close, { asChild: true, ref }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      type: "button",
      "aria-label": "Close",
      className: cn("absolute right-1.5 top-1.5", className),
      ...props
    },
    /* @__PURE__ */ React.createElement(Close_default, { "aria-hidden": "true" })
  ));
});

export {
  DrawerCloseTrigger
};
